import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { isDesktopRuntime } from '@/services/desktopAuth'

export function DesktopEntryRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()

  if (!isDesktopRuntime()) return <>{children}</>

  if (isLoading) {
    return (
      <main className="grid min-h-screen place-items-center bg-[var(--bg-canvas)] px-6 text-[var(--text-primary)]">
        <p className="text-base font-medium text-[var(--text-secondary)]" role="status">
          Restoring your desktop session…
        </p>
      </main>
    )
  }

  return <Navigate to={isAuthenticated ? '/app' : '/login'} replace />
}

export default DesktopEntryRoute
